import { evaluate } from "mathjs";
import { toNumber, Sin, Tan } from "../../components/Common";

import { DESIGN_TYPES } from "../../redux_store/configState";

export const getRoofAlignmentFromRef = (ref, areaData) => {
    let roof_alignment_default = "Back";
    if (ref.includes("Right")) roof_alignment_default = "RightSide";
    else if (ref.includes("Left")) roof_alignment_default = "Side";
    else if (ref.includes("Front")) roof_alignment_default = "Front";

    if (ref.startsWith("C")) {
        let cutout_side = "BackRight";
        if (ref.startsWith("CBR")) cutout_side = "BackRight";
        if (ref.startsWith("CBL")) cutout_side = "BackLeft";
        if (ref.startsWith("CFL")) cutout_side = "FrontLeft";
        if (ref.startsWith("CFR")) cutout_side = "FrontRight";
        let cutout_type = areaData.SHAPE.CUTOUTS?.[cutout_side + "-CutoutType"];

        if (cutout_type === "Angle") {
            let cutout_angle_r = Math.atan(
                areaData.SHAPE.CUTOUTS?.[cutout_side + "-WidthY"] / areaData.SHAPE.CUTOUTS?.[cutout_side + "-WidthX"]
            );
            if (Math.abs(cutout_angle_r) < 0.2) {
                if (cutout_side.includes("Front")) roof_alignment_default = "Front";
                else roof_alignment_default = "Back";
            } else {
                if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
                if (cutout_side.includes("Left")) roof_alignment_default = "Side";
            }
        } else if (ref.includes(" Y")) {
            if (cutout_side.includes("Right")) roof_alignment_default = "RightSide";
            roof_alignment_default = "Side";
        } else {
            if (cutout_side.includes("Front")) roof_alignment_default = "Front";
            else roof_alignment_default = "Back";
        }
    }
    return roof_alignment_default;
};

export const adjustOffsetForSide = (ref, offsets, roofAlignment, areaData) => {
    let local_pitching_height_adjustment = 0;
    if (areaData.SHAPE.DesignType === DESIGN_TYPES.FLAT && roofAlignment.includes("Front"))
        local_pitching_height_adjustment = Sin(areaData?.SHAPE?.RoofPitch) * areaData?.SHAPE?.Depth;
    offsets.v += local_pitching_height_adjustment;

    if (ref === "CBM") {
        let roof_pitch = areaData.SHAPE.RoofPitch;
        let cutout_depth = areaData.SHAPE.CUTOUTS["BackMid-WidthY"];
        let offset = cutout_depth * Tan(roof_pitch);
        offsets.v += offset;
        offsets.v_display = offset;
    }
    if (ref === "CBR X") {
        if (areaData.SHAPE.CUTOUTS["BackRight-CutoutType"] === "Step") {
            let roof_pitch = areaData.SHAPE.RoofPitch;
            let cutout_depth = areaData.SHAPE.CUTOUTS["BackRight-WidthY"];
            let offset = cutout_depth * Tan(roof_pitch);
            offsets.v += offset;
            offsets.v_display = offset;
        }
    }
    if (ref === "CBL X") {
        if (areaData.SHAPE.CUTOUTS["BackLeft-CutoutType"] === "Step") {
            let roof_pitch = areaData.SHAPE.RoofPitch;
            let cutout_depth = areaData.SHAPE.CUTOUTS["BackLeft-WidthY"];
            let offset = cutout_depth * Tan(roof_pitch);
            offsets.v += offset;
            offsets.v_display = offset;
        }
    }
    return offsets;
};

export const getOffsets = (
    schema,
    beam_height,
    roof_sheet_height,
    eaveValue,
    roofAlignment = false,
    vOffset = null, // set to null if want to reset to defaults only
    hOffset = null // set to null if want to reset to defaults only
) => {
    let offsets = { v: vOffset ? vOffset : 0, h: hOffset ? hOffset : 0 };
    // if (ATTACHMENT_TYPES[attachmentTypeValue]) {
    //     schema = ATTACHMENT_TYPES[attachmentTypeValue];
    //     if (schema?.variations && schema.variations[attachmentTypeVariation]) {
    //         schema = { ...schema, ...schema.variations[attachmentTypeVariation] };
    //     }
    // }

    let is_side = roofAlignment.includes("Side");

    if (schema) {
        const beam_width = window.LYSAGHT ? 50 : 65;

        if (!schema?.depth_offset_editable) {
            //change defaults is initialised, otherwise don't!
            if (schema?.display_name.includes("Flyover")) {
                offsets.h = -(eaveValue + 110 + 50 + 90);
            } else if (schema?.depth_offset_default !== undefined) {
                if (schema?.depth_offset_default === "150-Beam_Width") {
                    offsets.h = 150 - beam_width;
                } else offsets.h = schema?.depth_offset_default;
            }
        }

        if (is_side && schema?.height_offset_editable_side) {
        } else if (!schema?.height_offset_editable) {
            if (schema?.height_offset_default !== undefined) {
                if (typeof schema?.height_offset_default === "string") {
                    let expression = schema?.height_offset_default;
                    let scope = {
                        Beam_Height: beam_height,
                        Sheet_Height: roof_sheet_height,
                    };
                    console.log("expression", expression, scope);
                    offsets.v = evaluate(expression, scope);
                } else {
                    offsets.v = toNumber(schema?.height_offset_default);
                }
            }
        }

        let variation = schema;
        if (variation) {
            let new_h_offset = offsets.h;
            let new_v_offset = offsets.v;

            if (variation?.depth_offset_default !== undefined) {
                if (typeof variation?.depth_offset_default === "string") {
                    if (variation?.depth_offset_default.includes("150-Beam_Width")) {
                        new_h_offset = 150 - beam_width;
                    }
                } else {
                    new_h_offset = toNumber(variation?.depth_offset_default);
                }
            }

            if (variation?.height_offset_default === "Beam_Height") new_v_offset = beam_height ? beam_height : 0;
            else if (variation?.height_offset_default === "Beam_Height-50")
                new_v_offset = beam_height ? beam_height - 50 : 0;
            else if (variation?.height_offset_default === "-Sheet_Height")
                new_v_offset = roof_sheet_height ? -roof_sheet_height : 0;
            else if (variation?.height_offset_default)
                new_v_offset = toNumber(variation?.height_offset_default ? variation?.height_offset_default : 0);

            offsets.h = new_h_offset;
            offsets.v = new_v_offset;
        }

        if (vOffset !== null) {
            if (is_side && schema?.height_offset_editable_side) {
                offsets.v = vOffset;
            } else if (schema?.height_offset_editable) {
                offsets.v = vOffset;
            }
        }

        if (schema?.height_offset_max) {
            let max_height = toNumber(schema?.height_offset_max);
            if (max_height > 0 && offsets.v > max_height) offsets.v = max_height;
        }
        if (schema?.height_offset_min) {
            let min_height = toNumber(schema?.height_offset_min);
            if (offsets.v < min_height) offsets.v = min_height;
        }

        if (hOffset !== null) {
            if (schema?.depth_offset_editable) {
                offsets.h = hOffset;
            }
        }

        if (schema?.depth_offset_max) {
            let max_depth = toNumber(schema?.depth_offset_max);
            if (max_depth > 0 && offsets.h > max_depth) offsets.h = max_depth;
        }
        if (schema?.depth_offset_min) {
            let min_depth = toNumber(schema?.depth_offset_min);
            if (offsets.h < min_depth) offsets.h = min_depth;
        }

        return offsets;
    }
    return offsets;
};
